import {ShoppingValueObject} from "../../vo/content/ShoppingValueObject";
import {DataTransferObjectValidation} from "../../../type/Types";

export namespace ShoppingDataTransferObject {
    export type Post = {
        isActive: boolean
        // isCatalogPreferred: boolean
        exposedAt: string
        catalogRank: number | null
        mid: string | null
        reviewCount: number | null
        reviewScore: number | null
        mallCount: number | null
        storeName: string | null
        productName: string | null
        productImageUrl: string | null
        productNumber: string | null
        answer: string | null
        productPrice: bigint | null
        productUrl: string | null
        mainKeywordString: string | null
        mallSequence: string | null
        categoryId: string | null
        catalogMid: string | null
        catalogProductName: string | null
        catalogLowestPrice: bigint | null
        catalogDiscountedPrice: bigint | null
        catalogDeliveryFee: bigint | null
        amount: bigint | null
    }

    export namespace Post {
        export const description: Record<keyof Post, string> = ShoppingValueObject.description

        export const validation: DataTransferObjectValidation<Post> = {
            isActive(o: string): boolean {
                return o === 'true'
            },
            // isCatalogPreferred(o:string): boolean {
            //     return o === 'true'
            // },
            exposedAt(o: string): string | Error {
                try {
                    return new Date(o).toISOString().substring(0, 10)
                } catch (e) {
                    return new Error('exposedAt', { cause: e })
                }
            },
            catalogRank(o:string): number | null | Error {
                if(o.length === 0)
                    return null
                try{
                    return Number(o)
                }
                catch(e) {
                    return new Error('catalogRank',{cause: e})
                }

            },
            mid(o: string): string | null | Error {
                if (o.length === 0) {
                    return null
                }
                try {
                    BigInt(o)
                    return o
                } catch (e) {
                    return new Error('mid', { cause: e })
                }
            },
            reviewCount(o: string): number | null | Error {
                if (o.length === 0) {
                    return null
                }
                try {
                    return Number(o)
                } catch (e) {
                    return new Error('reviewCount', { cause: e })
                }
            },
            reviewScore(o: string): number | null | Error {
                if (o.length === 0) {
                    return null
                }
                try {
                    return Number(o)
                } catch (e) {
                    return new Error('reviewScore', { cause: e })
                }
            },
            mallCount(o: string): number | null | Error {
                if (o.length === 0) {
                    return null
                }
                try {
                    return Number(o)
                } catch (e) {
                    return new Error('mallCount', { cause: e })
                }
            },
            storeName(o: string): string | null {
                if (o.length === 0) {
                    return null
                } else {
                    return o
                }
            },
            productName(o: string): string | null {
                if (o.length === 0) {
                    return null
                } else {
                    return o
                }
            },
            productImageUrl(o: string): string | null {
                if (o.length === 0) {
                    return null
                } else {
                    return o
                }
            },
            productNumber(o: string): string | null {
                return o
            },
            answer(o: string): string | null {
                if (o.length === 0) {
                    return null
                } else {
                    return o
                }
            },
            productPrice(o: string): bigint | null | Error {
                if (o.length === 0) {
                    return null
                }
                try {
                    return BigInt(o)
                } catch (e) {
                    return new Error('productPrice', { cause: e })
                }
            },
            productUrl(o: string): string | null {
                if (o.length === 0) {
                    return null
                } else {
                    return o
                }
            },
            mainKeywordString(o: string): string | null {
                if (o.length === 0) {
                    return null
                } else {
                    return o
                }
            },
            mallSequence(o: string): string | null {
                if (o.length === 0) {
                    return null
                } else {
                    return o
                }
            },
            categoryId(o: string): string | null {
                if (o.length === 0) {
                    return null
                } else {
                    return o
                }
            },
            catalogMid(o: string): string | null {
                if (o.length === 0) {
                    return null
                } else {
                    return o
                }
            },
            catalogProductName(o: string): string | null {
                if (o.length === 0) {
                    return null
                } else {
                    return o
                }
            },
            catalogLowestPrice(o:string): bigint | null | Error {
                if(o.length === 0)
                    return null
                try{
                    return BigInt(o)
                }
                catch(e) {
                    return new Error('catalogLowestPrice',{cause: e})
                }

            },
            catalogDiscountedPrice(o:string): bigint | null | Error {
                if(o.length === 0)
                    return null
                try{
                    return BigInt(o)
                }
                catch(e) {
                    return new Error('catalogDiscountedPrice',{cause: e})
                }

            },
            catalogDeliveryFee(o:string): bigint | null | Error {
                if(o.length === 0)
                    return null
                try{
                    return BigInt(o)
                }
                catch(e) {
                    return new Error('catalogDeliveryFee',{cause: e})
                }

            },
            amount(o: string): bigint | null | Error {
                if (o.length === 0) {
                    return null
                }
                try {
                    return BigInt(o)
                } catch (e) {
                    return new Error('amount', { cause: e })
                }
            },
        }
    }

    export type Put = {
        isActive: boolean
        // isCatalogPreferred: boolean
        exposedAt: string
        catalogRank: number | null
        mid: string | null
        reviewCount: number | null
        reviewScore: number | null
        mallCount: number | null
        storeName: string | null
        productName: string | null
        productImageUrl: string | null
        productNumber: string | null
        answer: string | null
        productPrice: bigint | null
        productUrl: string | null
        mainKeywordString: string | null
        mallSequence: string | null
        categoryId: string | null
        catalogMid: string | null
        catalogProductName: string | null
        catalogLowestPrice: bigint | null
        catalogDiscountedPrice: bigint | null
        catalogDeliveryFee: bigint | null
        amount: bigint | null
    }

    export namespace Put {
        export const description: Record<keyof Put, string> = ShoppingValueObject.description

        export const validation: DataTransferObjectValidation<Put> = {
            isActive(o: string): boolean {
                return o === 'true'
            },
            // isCatalogPreferred(o:string): boolean {
            //     return o === 'true'
            // },
            exposedAt(o: string): string | Error {
                try {
                    return new Date(o).toISOString().substring(0, 10)
                } catch (e) {
                    return new Error('exposedAt', { cause: e })
                }
            },
            catalogRank(o:string): number | null | Error {
                if(o.length === 0)
                    return null
                try{
                    return Number(o)
                }
                catch(e) {
                    return new Error('catalogRank',{cause: e})
                }

            },
            mid(o: string): string | null | Error {
                if (o.length === 0) {
                    return null
                }
                try {
                    BigInt(o)
                    return o
                } catch (e) {
                    return new Error('mid', { cause: e })
                }
            },
            reviewCount(o: string): number | null | Error {
                if (o.length === 0) {
                    return null
                }
                try {
                    return Number(o)
                } catch (e) {
                    return new Error('reviewCount', { cause: e })
                }
            },
            reviewScore(o: string): number | null | Error {
                if (o.length === 0) {
                    return null
                }
                try {
                    return Number(o)
                } catch (e) {
                    return new Error('reviewScore', { cause: e })
                }
            },
            mallCount(o: string): number | null | Error {
                if (o.length === 0) {
                    return null
                }
                try {
                    return Number(o)
                } catch (e) {
                    return new Error('mallCount', { cause: e })
                }
            },
            storeName(o: string): string | null {
                if (o.length === 0) {
                    return null
                } else {
                    return o
                }
            },
            productName(o: string): string | null {
                if (o.length === 0) {
                    return null
                } else {
                    return o
                }
            },
            productImageUrl(o: string): string | null {
                if (o.length === 0) {
                    return null
                } else {
                    return o
                }
            },
            productNumber(o: string): string | null {
                return o
            },
            answer(o: string): string | null {
                if (o.length === 0) {
                    return null
                } else {
                    return o
                }
            },
            productPrice(o: string): bigint | null | Error {
                if (o.length === 0) {
                    return null
                }
                try {
                    return BigInt(o)
                } catch (e) {
                    return new Error('productPrice', { cause: e })
                }
            },
            productUrl(o: string): string | null {
                if (o.length === 0) {
                    return null
                } else {
                    return o
                }
            },
            mainKeywordString(o: string): string | null {
                if (o.length === 0) {
                    return null
                } else {
                    return o
                }
            },
            mallSequence(o: string): string | null {
                if (o.length === 0) {
                    return null
                } else {
                    return o
                }
            },
            categoryId(o: string): string | null {
                if (o.length === 0) {
                    return null
                } else {
                    return o
                }
            },
            catalogMid(o: string): string | null {
                if (o.length === 0) {
                    return null
                } else {
                    return o
                }
            },
            catalogProductName(o: string): string | null {
                if (o.length === 0) {
                    return null
                } else {
                    return o
                }
            },
            catalogLowestPrice(o:string): bigint | null | Error {
                if(o.length === 0)
                    return null
                try{
                    return BigInt(o)
                }
                catch(e) {
                    return new Error('catalogLowestPrice',{cause: e})
                }

            },
            catalogDiscountedPrice(o:string): bigint | null | Error {
                if(o.length === 0)
                    return null
                try{
                    return BigInt(o)
                }
                catch(e) {
                    return new Error('catalogDiscountedPrice',{cause: e})
                }

            },
            catalogDeliveryFee(o:string): bigint | null | Error {
                if(o.length === 0)
                    return null
                try{
                    return BigInt(o)
                }
                catch(e) {
                    return new Error('catalogDeliveryFee',{cause: e})
                }

            },
            amount(o: string): bigint | null | Error {
                if (o.length === 0) {
                    return null
                }
                try {
                    return BigInt(o)
                } catch (e) {
                    return new Error('amount', { cause: e })
                }
            },
        }
    }

    export type NsrtPostBack = {
        exposedAt: string
    }

    export namespace NsrtPostBack {
        export const description: Record<keyof NsrtPostBack, string> = ShoppingValueObject.description

        export const validation: DataTransferObjectValidation<NsrtPostBack> = {
            exposedAt(o: string): string | Error {
                try {
                    return new Date(o).toISOString().substring(0, 10)
                } catch (e) {
                    return new Error('exposedAt', { cause: e })
                }
            },
        }
    }
}

